import { jsx as _jsx } from "react/jsx-runtime";
import { sanitizeHtml } from '../utils';
const RenderHtml = ({ html }) => (_jsx("div", { className: "msg-content", dangerouslySetInnerHTML: { __html: sanitizeHtml(html) } }));
export default RenderHtml;
